import { Skeleton } from "@/shared/ui";

export default function OrganizationPageSkeleton() {
  return (
    <div className="flex flex-col gap-7">
      <div className="flex items-center gap-5 p-7 radius-3xl surface-base-fill">
        <Skeleton circle width={96} height={96} />
        <div className="flex-1 flex flex-col gap-2">
          <Skeleton height={18} width="40%" />
          <Skeleton height={14} width="60%" />
        </div>
      </div>

      {Array.from({ length: 3 }).map(function renderSectionSkeleton(_, index) {
        return (
          <div
            key={index}
            className="flex flex-col gap-4 p-7 radius-3xl surface-base-fill">
            <Skeleton height={18} width={200} />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Skeleton height={48} />
              <Skeleton height={48} />
              <Skeleton height={48} />
              <Skeleton height={48} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
